
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type {
    LanguageType,
    LanguagePayloadType
} from "@/common/types/language";

export async function languageList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `language/list${queryString}`
    );
}

export async function languageGet(
    language_id: string
) {
    return await clientAxios.get(
        `language/${language_id}/show`
    );
}

export async function languageAdd(
    payload: LanguagePayloadType
) {
    return await clientAxios.post(
        `language/create`,
        payload
    );
}

export async function languagePatch(
    language_id: string,
    payload: Partial<LanguageType>
) {
    return await clientAxios.patch(
        `language/${language_id}/patch`,
        { payload }
    );
}

export async function languageDel(
    language_id: string,
) {
    return await clientAxios.del(
        `language/${language_id}/delete`,
    );
}
